<template>
	<ui-modal-template>
		<template v-slot:title>
			{{ location ? __("Marktstandort bearbeiten") : __("Marktstandort anlegen") }}
		</template>

		<template v-slot:content>
			<ui-form class="h-full flex flex-col" :loading="loading" @submit="submitForm">
				<div class="p-0">

					<div class="flex flex-col px-6">
						<ui-input-group
							class="basis-full py-4"
							v-model="form.name"
							field="name"
							label="Name"
							:form="form"
							:required="false"
						/>

						<ui-input-group
							class="basis-full py-4"
							v-model="form.street"
							field="street"
							label="Straße + Hausnummer"
							:form="form"
							:required="false"
						/>
					</div>

					<div class="flex flex-col px-6 py-4">
						<crop-location-picker
							v-model="form.address"
							:form="form"
						/>
					</div>

				</div>

				<div class="bg-gray-100 p-6 px-6 mt-4">
					<div class="flex justify-end">
						<ui-button
							:disabled="loading"
							native-type="submit"
							label="Speichern"
						/>
					</div>
				</div>
			</ui-form>
		</template>
	</ui-modal-template>
</template>

<script>
import Vue from "vue";

export default {
	props: {
		location: {
			type: Object,
			default: null,
		},
	},

	data() {
		return {
			loading: false,
			form: Vue.observable({
				errors: {},
				hasErrors: false,
				clearErrors() {},
				name: this.location?.name ?? null,
				street: this.location?.street ?? null,
				address: {
					zip:     this.location?.zip ?? null,
					city:    this.location?.city ?? null,
					country: this.location?.country ?? "DE",
				},
			}),
		};
	},

	methods: {
		/**
		 * @return {void}
		 */
		async submitForm() {
			this.loading = true;

			const payload = {
				name:    this.form.name,
				street:  this.form.street,
				address: {
					zip:     this.form.address.zip,
					city:    this.form.address.city,
					country: this.form.address.country,
				},
			};

			try {
				if (this.location) {
					await axios.patch(
						this.$route("admin.market_locations.update", { id: this.location.id }),
						payload
					);

					this.$bus.$emit("modal:close");
					this.$bus.$emit("content:load");
				} else {
					const response = await axios.post(
						this.$route("admin.market_locations.store"),
						payload
					);

					this.$bus.$emit("modal:close");
					this.$bus.$emit("market-location:created", response.data.data);
				}
			} catch (error) {
				if (error.response?.status === 422) {
					this.$bus.$emit("form:invalid", error.response.data.errors);
				} else {
					this.$bus.$emit("modal:error", error);
				}
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>
